import { useRouteMatch } from 'react-router';

import {
  productDetailViewFragment,
  productDetailViewFragment_variants,
} from '@containers/ProductDetailContainer/queries/__generated__/productDetailViewFragment';
import { useUpdateEffect } from '@hooks';

import { IProductDetailRouteParams } from '../index';
import { trackItemInExponea } from '../tracking';

export const useTrackProductUrlChange = (
  product: productDetailViewFragment,
  variant: productDetailViewFragment_variants
) => {
  const match = useRouteMatch<IProductDetailRouteParams>();

  useUpdateEffect(() => {
    trackItemInExponea(product, variant);
  }, [match.params.productUrl]);
};
